import React from 'react';
import { Navigate } from 'react-router-dom';

// Lê o token do localStorage e decodifica o payload do JWT.
// Retorna null se não houver token, se estiver malformado ou se estiver expirado.
function getAuth() {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp && payload.exp * 1000 < Date.now()) return null;
        return payload;
    } catch {
        return null;
    }
}

/**
 * Protege rotas privadas. Sem token válido → redireciona para /login.
 * Com `adminOnly`, exige também role === 'admin' (senão → home).
 */
const RequireAuth = ({ children, adminOnly = false }) => {
    const auth = getAuth();
    if (!auth) return <Navigate to="/login" replace />;
    if (adminOnly && auth.role !== 'admin') return <Navigate to="/" replace />;
    return children;
};

export default RequireAuth;
